<script>
import { Inertia } from '@inertiajs/inertia'
import Edit from './edit.vue'

export default {
  extends: Edit,

  data() {
    return {
      ...Edit.data.call(this),
      title: 'Users :: Add User'
    }
  },

  methods: {
    submit() {
      Inertia.post(this.$route('users.store'), this.form)
    },
  },
}
</script>
